import * as React from 'react';
import './overview.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Dashboard from './dashboard/dashboard';

export const Overview: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path="/"
                    element={<Dashboard />}
                />
            </Routes>
        </BrowserRouter>
    );
};
